import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// React 19.2's dev-only performance tracking (logComponentRender) calls
// performance.measure() with a `detail` payload the browser must structured-
// clone. On long-running sessions with large component state that clone throws
// "DataCloneError: ... out of memory" — and because it happens inside React's
// commit phase, it crashes the whole app. We don't consume these dev measures,
// so swallow that specific failure rather than letting it take down the UI.
if (typeof performance !== 'undefined' && typeof performance.measure === 'function') {
  const originalMeasure = performance.measure.bind(performance);
  performance.measure = function patchedMeasure(...args: Parameters<Performance['measure']>) {
    try {
      return originalMeasure(...args);
    } catch {
      // Ignore DataCloneError from React's dev profiler; return a stub so any
      // caller expecting a PerformanceMeasure doesn't itself break.
      return {
        name: typeof args[0] === 'string' ? args[0] : '',
        entryType: 'measure',
        startTime: 0,
        duration: 0,
        detail: null,
        toJSON: () => ({}),
      } as PerformanceMeasure;
    }
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
